import channel from './channelDelegate';

class NativeDelegate {
    constructor() {
        this.messageHandleMap = {};

        channel.runtime.addDataListener((message) => {
            // console.log('NativeDelegate.onMessage receive message ', message);
            if (this.messageHandleMap[`${message.connectType}.${message.method}`]) {
                this.messageHandleMap[`${message.connectType}.${message.method}`](message);
            }
        });
    }

    getConnected() {
        return channel.runtime.isConnected;
    }

    createListeners(connectType, method, callback) {
        this.messageHandleMap[`${connectType}.${method}`] = callback;
    }

    destroyListeners(connectType, method){
        if( this.messageHandleMap[`${connectType}.${method}`]){
            this.messageHandleMap[`${connectType}.${method}`] = null;
            delete this.messageHandleMap[`${connectType}.${method}`];
        } else {
            console.log('destroy listener failed ', connectType, method);
        }
    }

    sendMessage(message, callback) {
        channel.runtime.sendMessage(message, callback);
    }

    addConnectListener(listener) {
        channel.runtime.addConnectListener(listener);
    }

    addDisconnectListener(listener) {
        channel.runtime.addDisconnectListener(listener);
    }
}

export default new NativeDelegate();